import React from "react";

export const DeliveryCollectionDetailContext = React.createContext(null);

export const useDeliveryCollectionDetailContext = () => {
  const context = React.useContext(DeliveryCollectionDetailContext);

  if (!context) throw new Error("Delivery Collection Detail Context not provided!");

  return context;
};
